import store from 'redux/store';
import { doCommand, undoCommand, redoCommand } from './actions';
import { Command, deserializeCommand } from './commands';
import { trackMiscAction } from 'analytics';

export function executeCommand(command: Command): void {
	command.execute();
	store.dispatch(doCommand(command));
}

export function undo(): void {
	const state = store.getState();
	const command = state.mode.commandStack[state.mode.commandStack.length - 1];
	if (command) {
		trackMiscAction('undo');
		const restoredCommand = deserializeCommand(command);
		restoredCommand.undo();
		store.dispatch(undoCommand());
	}
}

export function redo(): void {
	const state = store.getState();
	const command = state.mode.undoneCommands[state.mode.undoneCommands.length - 1];
	if (command) {
		trackMiscAction('redo');
		const restoredCommand = deserializeCommand(command);
		restoredCommand.redo();
		store.dispatch(redoCommand());
	}
}
